import React, { useEffect, useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import api from '../api';

// Riepilogo di cosa partira' verso IBS/Mirakl quando l'ordine marketplace passa a Rimborsato.
// Il rimborso e il chiudi-reclamo vengono inviati automaticamente al salvataggio.
export default function RimborsoMiraklInfo({ ordineId }) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ordineId) return;
    setLoading(true);
    api.get(`/ordini/${ordineId}/rimborso-mirakl`)
      .then(res => setInfo(res.data))
      .catch(() => setInfo(null))
      .finally(() => setLoading(false));
  }, [ordineId]);

  if (loading) return <div className="text-muted small mb-2"><Spinner animation="border" size="sm" /> Controllo il rimborso su IBS...</div>;
  if (!info || info.motivo_non_applicabile === 'Ordine non marketplace') return null;

  const euro = (v) => Number(v).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  if (!info.applicabile) {
    return <Alert variant="secondary" className="small py-2">IBS/Mirakl: {info.motivo_non_applicabile}. Si aggiorna solo il gestionale.</Alert>;
  }
  return (
    <Alert variant="danger" className="small py-2">
      <strong>Confermando, il rimborso parte anche su IBS/Mirakl e non si può annullare.</strong>
      {info.righe.length > 0 && (
        <ul className="mb-1 mt-1">
          {info.righe.map(r => (
            <li key={r.order_line_id}>
              {r.titolo || r.order_line_id}: {euro(r.amount)}{r.shipping_amount > 0 ? ` + spedizione ${euro(r.shipping_amount)}` : ''}
            </li>
          ))}
        </ul>
      )}
      <div>Totale al cliente: <strong>{euro(info.totale)}</strong>{info.reclami_aperti > 0 ? ` — il reclamo aperto verrà chiuso.` : ''}</div>
    </Alert>
  );
}
